module.exports = __webpack_public_path__ + "static/img/Sam_Docherty_mobile.7cf14c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sam_Docherty_mobile.jpg
// module id = HnNT
// module chunks = 0